import { MainCategoryEnum } from '@insights/insights-data-provider';
/**
 * AB Test service.
 */
export class ABTestService {
    initABTestClient;
    clientConnectPromise = null;
    client = null;
    constructor(initABTestClient) {
        this.initABTestClient = initABTestClient;
    }
    /**
     * Checks if an A/B feature is enabled.
     *
     * @param name Feature name.
     * @param [variation] Variation used when the test has more than two variations.
     * @returns True if the feature is enabled.
     */
    isFeatureEnabled(name, variation) {
        if (!this.client) {
            return false;
        }
        return this.client.isFeatureEnabled(name, variation);
    }
    /**
     * Returns active experiment.
     *
     * @returns Active experiment.
     */
    getActiveExperiment() {
        if (!this.client) {
            return null;
        }
        return this.client.getActiveExperiment();
    }
    /**
     * Sends an event.
     *
     * @param event Event.
     */
    async sendEvent({ name, category }) {
        const connectResponse = await this.connect();
        connectResponse.client?.reportEvent(category.mainCategory === MainCategoryEnum.conversion
            ? {
                eventKey: 'conversion',
                eventTags: {
                    event: name
                }
            }
            : {
                eventKey: name
            });
    }
    /**
     * Disconnects from AB testing client.
     */
    async disconnect() {
        const clientConnectPromise = this.clientConnectPromise;
        if (!clientConnectPromise) {
            return;
        }
        return clientConnectPromise.then(c => {
            c.client?.close();
            if (this.client === c.client) {
                this.client = null;
            }
            if (this.clientConnectPromise === clientConnectPromise) {
                this.clientConnectPromise = null;
            }
        });
    }
    async refresh() {
        const newClientPromise = this.initABTestClient();
        const client = await newClientPromise;
        if (client.success) {
            this.disconnect();
            this.clientConnectPromise = newClientPromise;
            this.client = client.client;
        }
        return client;
    }
    async connect() {
        return this.clientConnectPromise ?? this.refresh();
    }
    isConnected() {
        return this.client?.isDisconnected() === false;
    }
}
//# sourceMappingURL=ABTestService.js.map